module.exports = __webpack_public_path__ + "static/media/csm-logo.9c1bf030.svg";